window.addEventListener( 'load', function(event) {

    var body = document.querySelector('body');
  
    var navToggler = document.querySelector('.nav-toggler');
        navToggler.addEventListener('click', function() {
          body.classList.toggle('nav-is-visible');
        });
});